import React, { useState } from "react";
import {
  Divider,
  Text,
  Title,
  TextInput,
  Flex,
  Badge,
  Box,
  Button,
  Grid,
} from "@mantine/core";
import axios from "axios";
import toast from "react-hot-toast";

const LoyaltyMembershipCorrection = ({ info, fetchData, children }) => {
  const [membershipInfo, setMembershipInfo] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");

  function checkStatus() {
    setLoading(true);

    const req = {
      loyalty_membership_ident: value,
      loyalty_membership_id: info.id,
      user_id: info.user_id,
      variety: info.variety,
      campaign_effort_id: info?.additional_req_data?.campaign_effort_id,
    };

    axios
      .post(`/loyalty-memberships/status-check/`, req)
      .then(({ data }) => {
        setMembershipInfo({
          ...data.response[0],
        });

        if (info.variety === 2) {
          fetchVehicles();
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  }

  function fetchVehicles() {
    axios
      .post(`/users/${info.user_id}/user-vehicles/`, {
        user_id: info.user_id,
        status: "all",
        campaign_effort_id: info?.additional_req_data?.campaign_effort_id,
      })
      .then(({ data }) => {
        setVehicles(
          data.response.map((m) => ({
            ...m,
            user_vehicle_data_points: [],
          }))
        );
      })
      .catch((err) => {
        setVehicles([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function onSubmit() {
    const req = {
      loyalty_membership_ident: value,
      loyalty_membership_id: info.id,
      user_id: info.user_id,
      variety: info.variety,
      campaign_effort_id: info?.additional_req_data?.campaign_effort_id,
    };

    setLoading(true);

    axios
      .post(`/ride-challenge/hog-correction/`, req)
      .then(() => {
        toast.success("Membership updated!");
        fetchData();
        setValue("");
        setMembershipInfo(null);
      })
      .catch((err) => {
        toast.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  if (membershipInfo) {
    const showRollup = !membershipInfo.in_use && membershipInfo.verified;

    return (
      <div>
        {/* Current Membership: {info.ident} */}
        <Flex justify="center" gap="xs" align="center">
          <Title order={1} c="white">
            {value}
          </Title>
          {showRollup && (
            <>
              {membershipInfo.is_active ? (
                <Badge color="green" size="xs">
                  Active
                </Badge>
              ) : (
                <Badge color="red" size="xs">
                  Inactive
                </Badge>
              )}
            </>
          )}
        </Flex>
        {showRollup && (
          <Text align="center" size="xs" c="dimmed">
            current membership: {info.ident}
          </Text>
        )}
        {membershipInfo.in_use && (
          <>
            <Text align="center" c="red" fw={600} size="md">
              This membership number is in use by another user.
            </Text>
            <Flex justify="center" mt="md" gap="md">
              <CancelButton onClick={onCancelClick} />
            </Flex>
          </>
        )}
        {!membershipInfo.verified && !membershipInfo.in_use && (
          <>
            <Text align="center" c="red" fw={600} size="md">
              This membership number is not verified.
            </Text>
            <Flex justify="center" mt="md" gap="md">
              <CancelButton onClick={onCancelClick} />
            </Flex>
          </>
        )}
        {showRollup && (
          <Box mt="md">
            {membershipInfo.is_active ? (
              <Text c="white" fw={600} align="center">
                This membership is{" "}
                <span style={{ color: "var(--mantine-color-green-4)" }}>
                  active
                </span>
                .
              </Text>
            ) : (
              <Text c="white" fw={600} align="center">
                This membership is{" "}
                <span style={{ color: "var(--mantine-color-red-4)" }}>
                  inactive
                </span>
                .
              </Text>
            )}
            {info.variety === 1 && (
              <>
                {vehicles.length > 0 ? (
                  <Box mt="md" mb="xl">
                    <Text
                      w="50%"
                      mx="auto"
                      c="white"
                      mb="xl"
                      fw={600}
                      align="center"
                    >
                      If you confirm the correction, this membership ({value})
                      will be assigned to the following vehicles (
                      {vehicles.length}) and user vehicle datapoints (
                      {vehicles.reduce(
                        (acc, vehicle) =>
                          acc +
                          vehicle.user_vehicle_data_points.filter(
                            (f) => f.is_active
                          ).length,
                        0
                      )}
                      ):
                    </Text>
                    <Grid gutter="xs" justify="center" wrap="wrap">
                      {vehicles.map((vehicle) => {
                        const uvdps = vehicle.user_vehicle_data_points.filter(
                          (f) => f.is_active
                        );
                        const hasUvdps = uvdps.length > 0;
                        return (
                          <Grid.Col
                            key={vehicle.id}
                            span={{ base: 12, md: 6, lg: 4 }}
                          >
                            <Box
                              p="md"
                              style={{
                                backgroundColor: "var(--mantine-color-dark-4)",
                                borderRadius: "var(--mantine-radius-md)",
                                border: "1px solid var(--mantine-color-dark-3)",
                              }}
                            >
                              <Text align="center" c="white" size="sm" fw={600}>
                                {vehicle.year} {vehicle.make} {vehicle.model}
                                {vehicle.series && ` ${vehicle.series}`}
                              </Text>
                              <Text size="xs" c="gray.4" align="center">
                                {vehicle.vin.toUpperCase()}
                              </Text>
                              {hasUvdps && (
                                <Text c="gray.4" align="center" size="xs">
                                  {uvdps.length} UVDPs changed
                                </Text>
                              )}
                            </Box>
                          </Grid.Col>
                        );
                      })}
                    </Grid>
                  </Box>
                ) : (
                  <Box mt="md" mb="xl">
                    <Text fw={600} align="center" c="white">
                      There are no UVDPs to be changed. It is safe to submit
                      this correction.
                    </Text>
                  </Box>
                )}
              </>
            )}
            <Flex justify="center" mt="xl" gap="md" mb="lg">
              <Button onClick={onSubmit} loading={loading} radius="xl">
                Confirm Correction
              </Button>
              {children}
            </Flex>
          </Box>
        )}
      </div>
    );
  }

  return (
    <div>
      <Text fw={600} c="white">
        Current Membership: {info.ident}
      </Text>
      <Divider my="sm" />
      <TextInput
        label="Member ID (e.g. US1234567)"
        value={value}
        onChange={(e) => setValue(e.target.value.trim().toUpperCase())}
        size="lg"
      />
      <Button
        loading={loading}
        mt="xs"
        fullWidth
        disabled={!value}
        onClick={checkStatus}
        size="lg"
      >
        Submit
      </Button>
      <Flex justify="center" mt="md">
        {children}
      </Flex>
    </div>
  );
};

export default LoyaltyMembershipCorrection;
